import { useTheme } from '@chakra-ui/react';
import { useMemo } from 'react';
import type { SiteColor } from './lib';

const FALLBACK_INK = '#0b0c11';

/** Encre du site (jeton v2 du thème Chakra), pour calculer le texte lisible sur les couleurs du BO. */
export function useInk(): string {
  const theme = useTheme() as { colors?: { mmv2?: { ink?: string } } };
  return theme.colors?.mmv2?.ink ?? FALLBACK_INK;
}

type Mmv2Colors = Partial<Record<'brand' | 'brandSurface' | 'brandOn' | 'action' | 'actionSurface' | 'actionOn', string>>;

/** Marque et action du site (jetons v2 du thème Chakra) : les couleurs du BO qui leur ressemblent s'y alignent. */
export function useSitePalette(): SiteColor[] {
  const theme = useTheme() as { colors?: { mmv2?: Mmv2Colors } };
  const c = theme.colors?.mmv2;
  return useMemo(() => {
    const out: SiteColor[] = [];
    if (c?.brand && c.brandSurface && c.brandOn) out.push({ color: c.brand, surface: c.brandSurface, on: c.brandOn });
    if (c?.action && c.actionSurface && c.actionOn) out.push({ color: c.action, surface: c.actionSurface, on: c.actionOn });
    return out;
  }, [c?.brand, c?.brandSurface, c?.brandOn, c?.action, c?.actionSurface, c?.actionOn]);
}
